import React from 'react';
import { Button, Divider } from 'antd';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import { SidebarPanel, SidebarTitle, ButtonGroup } from '../styles';

interface PrebuiltTemplatesProps {
  onTemplateSelect: (type: string) => void;
  onClearAll: () => void;
  onFormatCode: () => void;
  onRestoreOriginal?: () => void;
  canRestore?: boolean;
}

const PrebuiltTemplates: React.FC<PrebuiltTemplatesProps> = ({
  onTemplateSelect,
  onClearAll,
  onFormatCode,
  onRestoreOriginal,
  canRestore,
}) => {
  return (
    <SidebarPanel>
      <SidebarTitle>{TEMPLATE_FORM_CONSTANTS.MESSAGES.EMAIL_TEMPLATES}</SidebarTitle>
      <ButtonGroup>
        <Button size="small" onClick={() => onTemplateSelect('welcome')}>
          📧 Welcome Email
        </Button>
        <Button size="small" onClick={() => onTemplateSelect('newsletter')}>
          📰 Newsletter
        </Button>
        <Button size="small" onClick={() => onTemplateSelect('promotional')}>
          🧾 Promotional
        </Button>
        <Button size="small" onClick={() => onTemplateSelect('transactional')}>
          ✅ Transactional
        </Button>
      </ButtonGroup>

      <Divider style={{ margin: '16px 0' }} />

      <SidebarTitle>{TEMPLATE_FORM_CONSTANTS.MESSAGES.ACTIONS}</SidebarTitle>
      <ButtonGroup>
        <Button size="small" danger onClick={onClearAll}>
          🗑️ {TEMPLATE_FORM_CONSTANTS.BUTTONS.CLEAR_ALL}
        </Button>
        <Button size="small" onClick={onFormatCode}>
          ✨ {TEMPLATE_FORM_CONSTANTS.BUTTONS.FORMAT_CODE}
        </Button>
        {canRestore && (
          <Button size="small" onClick={onRestoreOriginal}>
            🔄 {TEMPLATE_FORM_CONSTANTS.BUTTONS.RESTORE_ORIGINAL}
          </Button>
        )}
      </ButtonGroup>
    </SidebarPanel>
  );
};

export default PrebuiltTemplates;
